var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C5.584 2 2 5.584 2 10C2 14.416 5.584 18 10 18C14.416 18 18 14.416 18 10C18 5.584 14.416 2 10 2ZM10 14C9.56 14 9.2 13.64 9.2 13.2V10C9.2 9.56 9.56 9.2 10 9.2C10.44 9.2 10.8 9.56 10.8 10V13.2C10.8 13.64 10.44 14 10 14ZM10.8 6.8C10.8 7.24183 10.4418 7.6 10 7.6C9.55817 7.6 9.2 7.24183 9.2 6.8C9.2 6.35817 9.55817 6 10 6C10.4418 6 10.8 6.35817 10.8 6.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9d87edbee13e0cea39b33025b4384e36.svg";
export { ForwardRef as ReactComponent };